module.exports = __webpack_public_path__ + "img/DK35255745.7869087a.png";